import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import DoneIcon from '@mui/icons-material/Done';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Post } from '../../services/http';

export default function MissionPage() {
    const [campaigns, setCampaigns] = React.useState(false);
    const openInfoPopup = useStoreActions((actions) => actions.open);

    const send = async () => {
        const fromName = document.getElementById('fromName').value;
        const fromEmail = document.getElementById('fromEmail').value;
        const phone = document.getElementById('phone').value;
        const content = document.getElementById('content').value;
        console.log('fromName', fromName);
        const result = await Post('/api/donation/CreateContactUsItem', { fromName, fromEmail, phone, content });
        console.log('result', result);
        if (result.result) {
            openInfoPopup({ notice: 'הפניה נשלחה בהצלחה', reload: false });
        } else {
            openInfoPopup({ notice: result.message, reload: false });
        }
    };

    return (
        <main className="main text-page">
            <section className="head-section" style={{ backgroundImage: 'url(/img/backgroundImage.png)' }}>
                <h1 className="text-center-bg head-section__title _anim-items _anim-no-hide _fadeDown color-2 weight-60 font-70 f-normal" data-animate-delay="02">Why Us?
                    <p className="mb-0 f-16 text-white mt-20 f-normal">
                        Main {'>>'} <span className="color-3">Why Us</span>
                    </p>
                </h1>
            </section>

            <div class="container-fluid">
                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                    <div class="title color-2 weight-500 roboto f-normal">The mission:</div>
                    <div class="center-text">
                        <span class="center  weight-500 f-24 roboto f-normal">Our mission is to make the entire fundraising
                            process easy and available to everyone. </span><br />
                        <p className="f-16 weight-400 roboto color-4 center-text f-normal">
                            If you are looking to campaign for an individual or an organization, no matter its size, we offer
                            everything you need.
                            If you are fundraising for individuals who only need a non-profit platform to process donations, or for organizations who only need a link to accept donations, this will be included in your ‘World of Tzedaka’ membership. If you require a full campaign with articles, videos, graphics, design, and advertising, we have you covered <br /> with the services we offer through our partners at ‘TIG Solutions.’
                        </p>
                    </div>
                </div>
                <br />
                <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                    <div class="title color-2 weight-500 roboto f-normal">
                        THE ‘WORLD OF TZEDAKA’ PLATFORM:
                    </div>
                    <div class="center-text">
                        <span className="weight-500 f-24 roboto f-normal">‘World of Tzedaka’ is a non-profit organization, making all the donations on our platform tax-deductible.</span>
                        <br /><br />
                        <p className="f-16 weight-400 roboto color-4 center f-normal">‘World of Tzedaka’ does not take a percentage of any campaign donations except the basic credit card processing fees.
                            <br /><br />
                            The minimal fee for being a member is $28/mo on a month-to-month basis which will grant you an account with ‘World of Tzedaka’ and the ability to create <br /> campaigns.
                        </p>
                    </div>
                </div>
                <div className="container">
                    <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                        <br />
                        <div class="title color-2 weight-500 roboto f-normal">The benefits of becoming a member:</div>
                        <div class="flex">
                            <DoneIcon className="" style={{ marginRight: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
                            <p className="mb-0 weight-400 f-normal roboto f-16 color-4 pl-5px">By becoming a member of ‘World of Tzedaka’,&nbsp;
                                you will have access to our non-profit platform for your campaign with personal links.
                            </p>
                        </div>
                        <br />
                        <div class="flex">
                            <DoneIcon className="" style={{ marginRight: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
                            <p className="mb-0 weight-400 f-normal roboto f-16 color-4 pl-5px">
                                You will have the ability to accept tax-deductible donations, set goals and deadlines, and create fundraising teams.
                            </p>
                        </div>
                        <br />
                        <div class="flex">
                            <DoneIcon className="" style={{ marginRight: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
                            <p className="mb-0 weight-400 f-normal roboto f-16 color-4 pl-5px">
                                With your ‘World of Tzedaka’ account, you will have the ability&nbsp;
                                <strong>
                                    to create campaigns and manage them with full access and transparency of all the financial details.
                                </strong>

                                <div class="list">
                                    <div class="list-title">This includes:</div>
                                    <div class="list-item"><span>-</span>Viewing full details of current donations and future recurring donations.</div>
                                    <div class="list-item"><span>-</span>Details of donation processing fees.</div>
                                    <div class="list-item"><span>-</span>Total pending funds and available funds for withdrawal.</div>
                                    <div class="list-item"><span>-</span>And more.</div>
                                </div>
                            </p>
                        </div>
                        <br />
                        <div class="flex">
                            <DoneIcon className="" style={{ marginRight: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
                            <p className="mb-0 weight-400 f-normal roboto f-16 color-4 pl-5px">
                                You will also have the ability to accept donations <strong>in dollars or euros </strong>and see <strong>the exchange rate </strong>
                                details in your account, <strong>transfer </strong>your available funds to an Israeli account (3% processing fee), <strong>manage </strong>
                                your campaign advertising, and much more.
                            </p>
                        </div>
                    </div>
                </div>
                <br />
                <div className="container">
                    <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
                        <div class="title weight-500 roboto f-32">On the donors end:</div>
                        <div class="roboto weight-400 f-16 color-4">
                            Donors have the option to donate via credit card, ACH, PayPal, Zelle, and check.<br /><br />
                            Donations can be made in dollars or euros. The donor can choose to cover the credit card processing fee, remain anonymous, and set recurring donations.
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
